module.exports = __webpack_public_path__ + "img/0-your-pension-thumbnail.0dd8d4b2.png";